import React, { useState } from "react";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import { Helmet } from "react-helmet";
import DropDownInput from "../../../../components/Universal/DropDownInput.component";
import MemberFormValidation from "../../../../components/PagesComponents/Organizational/Management/Members/MemberFormValidation.component";
import { Formik } from "formik";
import "../../../../styles/Pages/Financial/CashOutFlow/MarketingEx/MarketingEx.style.css";
import Advertising from "./Advertising";
import DigitalPresence from "./DigitalPresence";
import Events from "./Events";
import Merchandise from "./Merchandise";
import Influencer from "./Influencer";
import PRMarket from "./PRMarket";
import DatePicker from "../../../../components/Universal/DatePicker.component";
import SearchIcon from "../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import UniversalTable from "../../../../components/Universal/Tables/UniversalTable.component";
import BsBoxArrowRight from "../../../../assets/Icons/Universal/BsBoxArrowRight.svg";

const marketingColumns = [
  { label: "Receipt id/Time", key: "receipt" },
  { label: "Marketing type", key: "type" },
  { label: "Description", key: "description" },
  { label: "Amount (INR)", key: "amount" },
  {
    label: "Paid amount (INR)",
    key: "paid",
    render: (row) => (
      <div>
        <div>{row.paidAmount}</div>
        <div style={{ color: "#2e7d32", fontSize: "12px" }}>
          {row.paymentMode}
        </div>
      </div>
    ),
  },
  {
    label: "Provider/partner",
    key: "provider",
    render: (row) => (
      <div>
        {row.partner}
        <div style={{ color: "#673ab7", fontSize: "12px" }}>{row.phone}</div>
      </div>
    ),
  },
  { label: "Verified by", key: "verifiedBy" },
  {
    label: "Receipts",
    key: "status",
    render: (row) => (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <p
          style={{
            display: "flex",
            alignItems: "center",
            color: "#673ab7",
            cursor: "pointer",
            gap: "4px",
          }}
          className="hover-underline"
        >
          Receipt
          <img
            src={BsBoxArrowRight}
            style={{ height: "18px", width: "18px" }}
            alt="BsBoxArrowRight"
          />
        </p>
        <div
          style={{
            display: "inline-block",
            marginTop: "4px",
            background:
              row.status.toLocaleLowerCase() === "All paid".toLocaleLowerCase()
                ? "#4caf50"
                : "#FF9D00",
            color: "#fff",
            padding: "6px 12px",
            borderRadius: "6px",
            fontSize: "12px",
            cursor: "pointer",
          }}
        >
          {row.status}
        </div>
      </div>
    ),
  },
];

const marketingData = [
  {
    receipt: "23457289056\n10:24 AM",
    type: "Advertising & promotion",
    description:
      "Inspection is near about two hours within a campus. Mainly school building. It touches a world class standard.",
    amount: "₹ 36,000",
    paidAmount: "₹ 18,000",
    paymentMode: "UPI",
    partner: "Mahi Enterprise",
    phone: "9876543210",
    verifiedBy: "Jaheer Ahmad",
    status: "Pay due",
  },
  {
    receipt: "23457289056\n10:24 AM",
    type: "Advertising & promotion",
    description:
      "Inspection is near about two hours within a campus. Mainly school building.",
    amount: "₹ 36,000",
    paidAmount: "₹ 36,000",
    paymentMode: "Net banking",
    partner: "Mahi Enterprise",
    phone: "9876543210",
    verifiedBy: "Jaheer Ahmad",
    status: "All paid",
  },
  {
    receipt: "23457289056\n10:24 AM",
    type: "Advertising & promotion",
    description:
      "Inspection is near about two hours within a campus. Mainly school building.",
    amount: "₹ 36,000",
    paidAmount: "₹ 18,000",
    paymentMode: "Debit card",
    partner: "Mahi Enterprise",
    phone: "9876543210",
    verifiedBy: "Jaheer Ahmad",
    status: "Pay due",
  },
  {
    receipt: "23457289056\n10:24 AM",
    type: "Advertising & promotion",
    description:
      "Inspection is near about two hours within a campus. Mainly school building.",
    amount: "₹ 36,000",
    paidAmount: "₹ 18,000",
    paymentMode: "Cash",
    partner: "Mahi Enterprise",
    phone: "9876543210",
    verifiedBy: "Jaheer Ahmad",
    status: "All Paid",
  },
];

const Body = () => {
  const [selectedExpense, setSelectedExpense] = useState("");
  const [showAllHistory, setShowAllHistory] = useState(false);

  const expenseList = [
    "Advertising & Promotions",
    "Digital Presence",
    "Organizing events",
    "Branding Merchandise",
    "Influencer marketing",
    "PR marketing",
  ];
  // Map selection to components
  const componentMap = {
    "Advertising & Promotions": <Advertising />,
    "Digital Presence": <DigitalPresence />,
    "Organizing events": <Events />,
    "Branding Merchandise": <Merchandise />,
    "Influencer marketing": <Influencer />,
    "PR marketing": <PRMarket />,
  };
  if (showAllHistory)
    return (
      <section className="MarketingExAllPaymentHistoryContainer">
        <Helmet>
          <title>All payments history</title>
          <meta
            name="description"
            content="Monitor and analyze cash inflow trends and contributions."
          />
          <meta
            name="keywords"
            content="cash inflow, financial dashboard, cash flow analysis, business finance"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
        <PageHeader title={"All payments history"} />
        <div className="market-expense-payment-hisotry-container">
          <div
            style={{
              marginTop: "1rem",
              backgroundColor: "white",
              padding: "2rem",
              borderRadius: "10px",
            }}
            className="HistorySection"
          >
            <div className="history-header mb-1">
              <h3
                style={{
                  color: "var(--grayColor)",
                  fontWeight: "500",
                  marginBottom: "0.5rem",
                }}
              >
                All material & resources payment history
              </h3>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "3fr 2fr",
                  gap: "1rem",
                }}
                className="inputs-buttons"
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: "1rem",
                  }}
                  className="input"
                >
                  <div className="searchInputContainer">
                    <button className="searchBtn">
                      <img src={SearchIcon} alt="Search" />
                    </button>
                    <input
                      style={{ width: "200px" }}
                      type="text"
                      className="pageHeaderInput"
                      placeholder="Search id"
                    />
                  </div>
                  <DatePicker
                    label=""
                    name="date"
                    setFieldValue={() => {}}
                    placeholder={"Choose a date"}
                    errors={() => {}}
                  />
                  <DropDownInput
                    setFieldValue={() => {}}
                    suggestionList={[]}
                    placeholder={"Choose Categories"}
                  />
                </div>
                <div
                  style={{ display: "flex", gap: "1rem" }}
                  className="buttons"
                >
                  <button
                    style={{
                      backgroundColor: "var(--blueColor1)",
                      borderColor: "var(--blueColor1)",
                    }}
                    onClick={() => setShowAllHistory(false)}
                    className="actionBtn"
                  >
                    Go to material and resources
                  </button>
                  <button className="actionBtn">Download</button>
                </div>
              </div>
            </div>
            <div className="history-table">
              <UniversalTable
                columns={marketingColumns}
                data={marketingData}
                footer={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: "1rem",
                    }}
                  >
                    <div className="indicator-box filled-orange">
                      Total count: <span style={{ color: "white" }}>236</span>
                    </div>
                    <div className="indicator-box outlined-orange">
                      Due amount:{" "}
                      <span style={{ color: "var(--tableColor)" }}>
                        ₹ 2,60,560
                      </span>
                    </div>
                    <div className="indicator-box outlined-blue">
                      Total amounts:{" "}
                      <span style={{ color: "#00B7FF" }}>₹ 2,60,560</span>
                    </div>
                    <div className="indicator-box filled-blue">
                      Paid amount:{" "}
                      <span style={{ color: "white" }}>₹ 2,60,560</span>
                    </div>
                  </div>
                }
              />
            </div>
          </div>
        </div>
      </section>
    );
  return (
    <section className="MarketingExContainer">
      <Helmet>
        <title>Marketing Ex.</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="cash inflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <PageHeader title={"Marketing Ex."} />

      <div className="AddMarketingExpenseBox">
        <div className="upper">
          <h3>Add Marketing Expense</h3>
          <button
            onClick={() => setShowAllHistory(true)}
            className="blueActionBtnLight"
          >
            All payment history
          </button>
        </div>

        <Formik
          initialValues={{ expenseFor: "" }}
          validationSchema={MemberFormValidation}
          onSubmit={(values) => {
            console.log("Form Submitted:", values);
          }}
        >
          {({ setFieldValue, handleSubmit, touched, errors, setTouched }) => (
            <DropDownInput
              name="expenseFor"
              label="Expense For"
              setFieldValue={(val) => {
                setFieldValue("expenseFor", val);
                setSelectedExpense(val); // <-- set state here
                console.log("Selected Expense Category:", val);
              }}
              placeholder="Choose an expense category"
              suggestionList={expenseList}
              errors={errors}
              touched={touched}
              setTouched={(name, isTouched) =>
                setTouched({ [name]: isTouched })
              }
            />
          )}
        </Formik>
        <div
          style={{
            marginTop: "16px",
            borderTop: "1px solid var(--grayBorder)",
          }}
          className="main-body"
        >
          {/* Dynamically render selected component */}
          {componentMap[selectedExpense] || (
            <p style={{ padding: "1rem", color: "#999" }}>
              Please select a category to continue.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Body;
